import * as yup from "yup";

import { EditorMode } from "../../Editor/types";
import { LiveFormFieldProps } from "./LiveFormField/types";

export enum FormFieldTypes {
  TEXT = "Text",
  PASSWORD = "Password",
  CHECKBOXES = "Checkboxes",
  MULTIPLECHOICE = "Multiple Choice",
  TEXTAREA = "Textarea",
  SELECT = "Select",
  DATE = "Date",
  CONTENT = "Content",
  NUMBER = "Number",
  CURRENCY = "Currency",
  DROPDOWN = "Drop Down",
  // TYPOGRAPHY = "Typography",
  // FILEUPLOAD = "FileUpload",
  // LINEARSCALE = "LinearScale",
}

export interface validationSchema {}

export interface FormBuilderProps {
  /**
   * Establishes which version of the FormBuilder components should show
   */
  mode?: EditorMode;

  /**
   * The list of form fields that the form builder shows
   */
  data?: LiveFormFieldProps[];

  /**
   * the props to use for the SortableList component
   */
  sortableSettingsOverride?: SortableListProps;

  /**
   * The style to use on all form field
   */
  globalFieldStyle?: {
    labelStyle: React.CSSProperties;
    inputStyle: React.CSSProperties;
    containerStyle: React.CSSProperties;
    validationStyle: React.CSSProperties;
  };

  /**
   * A Yup schema or a function that returns a Yup schema.
   */
  validationSchema?: yup.InferType<typeof validationSchema>;

  /**
   * Triggers when one of the fields change
   * - returns the item that changed, the complete mutated data array, and the validation status
   */
  onChange?: (data: LiveFormFieldProps[]) => void;

  /**
   * Triggers when one of the fields triggers a blur event
   * - returns the item that changed, the complete mutated data array, and the validation status
   */
  onBlur?: (data: LiveFormFieldProps[]) => void;
}
